import { useContext } from 'react';
import { AutosaveStatusContext } from '../contexts/contexts';

export const useAutosaveStatus = () => useContext(AutosaveStatusContext);
